import React from "react";
import ScheduleModel from "../models/schedule_model";

type Props = {
    scheduleMap: Map<number, ScheduleModel>;
    onUpdateSchedule: (args: {
        day: number;
        time?: string;
        isActive?: boolean;
    }) => void;
};

export default class ScheduleTableWidget extends React.Component<Props> {
    render(): React.ReactNode {
        const { scheduleMap, onUpdateSchedule } = this.props;

        return (
            <div className="overflow-x-auto">
                <table className="table-fixed w-full text-center border-collapse">
                    <thead>
                        <tr className="bg-gray-300">
                            <th className="p-2 border border-gray-400 w-1/12">
                                Hari
                            </th>
                            <th className="p-2 border border-gray-400 w-2/12">
                                Waktu
                            </th>
                            <th className="p-2 border border-gray-400 w-1/12">
                                Status
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {[...scheduleMap.values()].map((schedule) => (
                            <tr
                                key={schedule.day}
                                className="bg-white hover:bg-gray-100 transition"
                            >
                                {/* Convert angka ke nama hari */}
                                <td className="p-2 border border-gray-400">
                                    {
                                        [
                                            "",
                                            "Senin",
                                            "Selasa",
                                            "Rabu",
                                            "Kamis",
                                            "Jumat",
                                            "Sabtu",
                                            "Minggu",
                                        ][schedule.day]
                                    }
                                </td>

                                {/* Input time dengan format HH:mm */}
                                <td className="p-2 border border-gray-400">
                                    <input
                                        type="time"
                                        value={schedule.time}
                                        onChange={(e) =>
                                            onUpdateSchedule({
                                                day: schedule.day,
                                                time: e.target.value,
                                                isActive: schedule.isActive,
                                            })
                                        }
                                        className="w-28 px-2 py-1 border border-gray-300 rounded"
                                    />
                                </td>

                                {/* Toggle isActive */}
                                <td className="p-2 border border-gray-400">
                                    <input
                                        type="checkbox"
                                        checked={schedule.isActive}
                                        onChange={(e) =>
                                            onUpdateSchedule({
                                                day: schedule.day,
                                                time: schedule.time,
                                                isActive: e.target.checked,
                                            })
                                        }
                                    />
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        );
    }
}
